const INIT_SELECTED_INFO = "@@INIT_SELECTED_INFO";
const SELECTED_CMP_CD = "@@SELECTED_CMP_CD";
const SELECTED_BRAND_CD = "@@SELECTED_BRAND_CD";
const SELECTED_STORE_CD = "@@SELECTED_STORE_CD";

const initialState = {};
function init() {
  return {
    type: INIT_SELECTED_INFO
  };
}

function applyInit() {
  return {};
}

function setSelectCmpCd(cmpCd) {
  return {
    type: SELECTED_CMP_CD,
    cmpCd
  };
}

function applySetSelectCmpCd(state, action) {
  const { cmpCd } = action;
  return {
    ...state,
    cmpCd
  };
}

function setSelectBrandCd(brandCd) {
  return {
    type: SELECTED_BRAND_CD,
    brandCd
  };
}

function applySetSelectBrandCd(state, action) {
  const { brandCd } = action;
  return {
    ...state,
    brandCd
  };
}

function setSelectStoreCd(storeCd) {
  return {
    type: SELECTED_STORE_CD,
    storeCd
  };
}

function applySetSelectStoreCd(state, action) {
  const { storeCd } = action;
  return {
    ...state,
    storeCd
  };
}

function reducer(state = initialState, action) {
  switch (action.type) {
    default:
      return state;
    case INIT_SELECTED_INFO:
      return applyInit();
    case SELECTED_CMP_CD:
      return applySetSelectCmpCd(state, action);
    case SELECTED_BRAND_CD:
      return applySetSelectBrandCd(state, action);
    case SELECTED_STORE_CD:
      return applySetSelectStoreCd(state, action);
  }
}

const actionCreator = {
  init,
  setSelectCmpCd,
  setSelectBrandCd,
  setSelectStoreCd
};

export { actionCreator as selectedActions };

export default reducer;


